import React, { Component } from 'react'
import ContMessageI18N from '../../containers/ContMessageI18N';

const originAppCodeList = ['MPD'];
const typeList = ['NV_SFS', 'VN_FI'];
const subTypeList = { 'VN_FI': ['VAC', 'LOA', 'LLD'], 'NV_SFS': ['LOAN', 'FL', 'PL', 'LOAN_INS', 'FL_INS', 'PL_INS'] }

class TestVehicleDiscountAppliedRef extends Component {

	constructor(props) {
		super(props);
		this.state = TestVehicleDiscountAppliedRef.getStateFromProps(props);
		this.onChange = props.onChange;
	}
	static getStateFromProps(props) {
		let retainedApp = props.data.originAppCode;
		if(!retainedApp){
			retainedApp = originAppCodeList[0];
		}
		let retainedType = props.data.type;
		if(!retainedType){
			retainedType = typeList[0];
		}
		let retainedSubType = props.data.subType;
		if(!retainedSubType && subTypeList[retainedType]){
			retainedSubType = subTypeList[retainedType][0];
		}
		return {
			externalId: props.data.externalId,
			originAppCode: retainedApp,
			type: retainedType,
			subType: retainedSubType
		};
	}
	static getDerivedStateFromProps(props, currentState) {
		if (currentState !== TestVehicleDiscountAppliedRef.getStateFromProps(props)) {
			return TestVehicleDiscountAppliedRef.getStateFromProps(props);
		}
		return null;
	}

	onChange = function (data) { }

	handleChange(data, name) {
		var updateVar = { ...this.state };
		updateVar[name] = data[name];
		this.onChange(updateVar);
	}
	handleChangeGeneric = name => event => { this.handleChange({ [name]: event.target.value }, name); };
	getLabel( fieldname, i18nKey) { return this.props.settings.isDevelopperView ? fieldname	
								: this.getMessage(i18nKey); }
	getMessage(i18nKey, optionValue) {
		let prefix = null;
		if (optionValue) {
			prefix = `${optionValue} - `;
		}
		return <ContMessageI18N i18n={i18nKey} optionValue={optionValue} prefix={prefix} />
	}

	getItemLabel(value, fieldname) {
			return (
				this.getMessage(`vehicle.discountAppliedRef.${fieldname}.${value}`, value)
			)
	}

	render() {
		return (
			<React.Fragment>
				<div className="col-auto">
					<label htmlFor={`discountAppliedRef-externalId-${this.state.externalId}`} className="form-label">
						{this.getLabel('externalId', 'vehicle.discountAppliedRef.externalId')}
					</label>
					<input id={`discountAppliedRef-externalId-${this.state.externalId}`} type="text" className="form-control"
						value={this.state.externalId} onChange={this.handleChangeGeneric('externalId')} />
				</div>
				<div className="col-auto form-floating">
					<select className="form-select" id={`discountAppliedRef-originAppCode-${this.state.externalId}`}
						onChange={this.handleChangeGeneric('originAppCode')} value={this.state.originAppCode}>
						{originAppCodeList.map((code, index) => (
							<React.Fragment key={index}>{this.getItemLabel(code, 'originAppCode')}</React.Fragment>
						))}
					</select>
					<label htmlFor={`discountAppliedRef-originAppCode-${this.state.externalId}`} >
						{this.getLabel('originAppCode', 'vehicle.discountAppliedRef.originAppCode')}
					</label>
				</div>
				<div className="col-auto form-floating">
					<select className="form-select" id={`discountAppliedRef-type-${this.state.externalId}`}
						onChange={this.handleChangeGeneric('type')} value={this.state.type}>
						{typeList.map((code, index) => (
							<React.Fragment key={index}>{this.getItemLabel(code, 'type')}</React.Fragment>
						))}
					</select>
					<label htmlFor={`discountAppliedRef-type-${this.state.externalId}`} >
						{this.getLabel('type', 'vehicle.discountAppliedRef.type')}
					</label>
				</div>
				<div className="col-auto form-floating">
					<select className="form-select" id={`discountAppliedRef-subType-${this.state.externalId}`}
						onChange={this.handleChangeGeneric('subType')} value={this.state.subType}>
						{subTypeList[this.state.type] && subTypeList[this.state.type].map((code, index) => (
							<React.Fragment key={index}>{this.getItemLabel(code, 'subType')}</React.Fragment>
						))}
					</select>
					<label htmlFor={`discountAppliedRef-subType-${this.state.externalId}`} >
						{this.getLabel('subType', 'vehicle.discountAppliedRef.subType')}
					</label>
				</div>
			</React.Fragment>
		)
	}
}

export default (TestVehicleDiscountAppliedRef)
